// extracted by mini-css-extract-plugin
export default {"container":"JobNote_container__DuqKV","listNote":"JobNote_listNote__qWRNq","noDataAvailable":"JobNote_noDataAvailable__VSaTn"};